import { clubbiStyled } from 'clubbi-ui'

export const StyledTag = clubbiStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.brandYellow[60],
  height: '15px',
  border: 'none',
  borderRadius: '2px',
  fontSize: '10px',
  color: '#3C3C3C',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  textAlign: 'center',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  padding: '2px',

  [theme.breakpoints.up('sm')]: {
    height: '20px',
    fontSize: '12px',
  },
}))

export const StyledTooltip = clubbiStyled('div')<{
  direction: 'right' | 'left'
}>(({ direction, theme }) => ({
  backgroundColor: 'black',
  height: '30px',
  width: '156px',
  borderRadius: '4px',
  fontSize: '9px',
  color: 'white',
  position: 'absolute',
  right: direction === 'right' ? '0px' : 'auto',
  marginTop: '5px',
  textAlign: 'left',
  lineHeight: '110%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '6px',
  zIndex: 49,
  fontWeight: 400,
  opacity: '90%',

  [theme.breakpoints.up('sm')]: {
    fontSize: '12px',
    height: '36px',
    width: '210px',
  },
}))
